import {
  Button,
  Grid,
  Link,
  Paper,
  Stack,
  Tooltip,
  Typography,
} from '@mui/material';
import React from 'react';
import { useLocation } from 'react-router-dom';
import { Login } from './Login';
import './styles.css';
import { SignUp } from './SignUp';
import { Profile } from '@par/shared/types/player';
import { Verify } from './Verify';
import { ResetPassword } from './ResetPassword';
import { ForgotPassword } from './ForgotPassword';
import { FaDiscord, FaTwitter } from 'react-icons/fa';

type PropTypes = {
  setProfile: (profile: Profile) => void;
};

export const Auth = ({ setProfile }: PropTypes) => {
  const location = useLocation();
  const isVerify = location.pathname.includes('/verify');
  const isLogin = location.pathname === '/login';
  const isSignUp = location.pathname === '/signup';
  const isForgotPassword = location.pathname.includes('/forgot-password');
  const isResetPassword = location.pathname.includes('/reset-password');
  return (
    <>
      <div className="login-container">
        <Grid
          container
          spacing={0}
          justifyContent="center"
          direction="row"
          className="login-form-row"
        >
          <Grid
            container
            direction="column"
            justifyContent="center"
            spacing={2}
            className="login-form"
          >
            <Stack
              direction="row"
              spacing={5}
              sx={{ display: 'flex', justifyContent: 'center' }}
            >
              <Typography>
                <Tooltip title="Join our Discord!" placement="top">
                  <Button
                    component={Link}
                    href="https://discord.gg/upX48KPfHd"
                    target="_blank"
                    startIcon={<FaDiscord size="2em" />}
                  ></Button>
                </Tooltip>
              </Typography>
              <Typography>
                <Tooltip title="Follow us on Twitter!" placement="top">
                  <Button
                    component={Link}
                    href="https://twitter.com/ParTrivia"
                    target="_blank"
                    startIcon={<FaTwitter size="2em" />}
                  ></Button>
                </Tooltip>
              </Typography>
            </Stack>
            <Paper
              variant="elevation"
              elevation={2}
              className="login-background"
            >
              {isVerify ? <Verify setProfile={setProfile}></Verify> : null}
              {isLogin ? <Login setProfile={setProfile}></Login> : null}
              {isSignUp ? <SignUp setProfile={setProfile}></SignUp> : null}
              {isForgotPassword ? <ForgotPassword></ForgotPassword> : null}
              {isResetPassword ? (
                <ResetPassword setProfile={setProfile}></ResetPassword>
              ) : null}
            </Paper>
          </Grid>
        </Grid>
      </div>
    </>
  );
};
